// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: transparent;
  --border-style: none;
  --box-shadow: none;
  --padding-start: 12px;
  --padding-end: 8px;
  outline: none;
  color: var(--ion-color-primary);
}
@media (width < 390px) {
  ion-button {
    font-size: 9px;
  }
}

.icon-only {
  font-size: var(--icon-size, 22px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EAEA,+BAAA;AAAF;AAEE;EAVF;IAWI,cAAA;EACF;AACF;;AAEA;EACE,4CAAA;AACF","sourcesContent":["ion-button {\n  --background: transparent;\n  --border-style: none;\n  --box-shadow: none;\n  --padding-start: 12px;\n  --padding-end: 8px;\n  outline: none;\n\n  color: var(--ion-color-primary);\n\n  @media (width < 390px) {\n    font-size: 9px;\n  }\n}\n\n.icon-only {\n  font-size: var(--icon-size, 22px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
